module.exports = __webpack_public_path__ + "img/icon_recenter_2.3c87e570.svg";